import styled from '@emotion/styled';
import { Button, Flex, Stack, Text } from '@pairy/pds-react';

export const Container = styled(Stack)`
  border: 1px solid ${({ theme }) => theme.colors.zinc_200};
  border-radius: 8px;
`;

export const LinkBlueWrapper = styled(Flex)`
  width: 100%;

  justify-content: space-between;
  padding: 16px;
  background-color: ${({ theme }) => theme.colors.skyblue_50};
  border-radius: 8px;

  &:hover {
    background-color: ${({ theme }) => theme.colors.skyblue_100};
    cursor: pointer;
  }
`;

export const LinkWrapper = styled(Text)`
  overflow: hidden;
  width: fit-content;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const LinkDeleteButton = styled(Button)`
  height: fit-content;
  flex-shrink: 0;
`;

export const CopyButtonWrapper = styled.button`
  display: flex;
  width: fit-content;
  flex-grow: 1;
  flex-shrink: 0;
  align-items: center;
  justify-content: flex-end;
  margin-left: 16px;
  color: ${({ theme }) => theme.colors.skyblue_600};
  gap: 8px;
`;
